import { Countries } from 'data/countries';

export const getCountryNameFromCountryCode = (code: string) => {
  return Countries.find((country) => country.code === code)?.name;
};
